module.exports = "<router-view class=\"profile\"></router-view>"